import React, {useEffect, useState} from 'react'
import moment from 'moment'

interface DetailV {
  id: string
  centreDefaut: {nom: string}
  codeMoteur: string
  cylindre: string
  debutPhase: string
  finPhase: string
  groupe: string
  marque: {nom: string}
  nom: string
  phase: string
  vin: string
  puissance: string
  type: {libelle: string; groupe: {libelle: string}}
}

const VehicleData = (props) => {
  const {
    immatriculation,
    vehicleInfo,
    setImmatriculationValide,
    closeBtn,
    infoModele,
    isEditable,
    setData,
    setShowDetailVehicule,
    loading,
  } = props
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [displayAdditionalInfo, setDisplayAdditionalInfo] = useState<boolean>(false)
  const [displayAdditionalInfoImmat, setDisplayAdditionalInfoImmat] = useState<boolean>(false)
  const [dataV, setDataV] = useState<DetailV>(() => {
    const initialInfoModele: DetailV = {
      id: '',
      centreDefaut: {nom: ''},
      codeMoteur: '',
      cylindre: '',
      debutPhase: '',
      finPhase: '',
      groupe: '',
      marque: {nom: ''},
      nom: '',
      phase: '',
      vin: '',
      puissance: '',
      type: {libelle: '', groupe: {libelle: ''}},
    }
    return infoModele[0] || initialInfoModele
  })

  useEffect(() => {
    setDataV(infoModele[0])
    setIsEdit(false)
  }, [infoModele[0]])

  const handleInputChange = (column, newValue: string) => {
    setDataV((prevData) => {
      if (column === 'marque') {
        return {
          ...prevData,
          marque: {
            ...prevData.marque,
            nom: newValue,
          },
        }
      } else if (column === 'centre') {
        return {
          ...prevData,
          centreDefaut: {
            ...prevData.centreDefaut,
            nom: newValue,
          },
        }
      } else if (column === 'type') {
        return {
          ...prevData,
          type: {
            ...prevData.type,
            libelle: newValue,
          },
        }
      } else if (column === 'groupe') {
        return {
          ...prevData,
          type: {
            ...(prevData.type ?? {libelle: '', groupe: {libelle: ''}}),
            groupe: {
              ...prevData.type?.groupe,
              libelle: newValue,
            },
          },
        }
      } else {
        return {
          ...prevData,
          [column as keyof DetailV]: newValue,
        }
      }
    })
  }

  const handleSaveInfo = () => {
    setIsEdit(false)
    setData(dataV?.id, dataV)
  }

  return (
    <>
      {loading ? (
        <div className='text-center'>
          <span className='ms-2'>Chargement...</span>
          <span className='spinner-border spinner-border-sm align-middle ms-2 w-30px h-30px'></span>
        </div>
      ) : (
        <div className='col p-3'>
          <div className='row'>
            {!vehicleInfo && infoModele?.length == 0 && immatriculation ? (
              <>
                <div className='d-flex mb-5'>
                  <label className='col p-1 fw-bold fs-3 text-gray-600'>
                    {immatriculation.stecMarque} {immatriculation.stecModele}{' '}
                    {immatriculation.sversion}
                  </label>
                  {closeBtn && (
                    <span className={'btn btn-icon btn-bg-light btn-active-color-primary btn-sm'}>
                      <i
                        className='ki-duotone ki-cross fs-3x cursor-pointer'
                        onClick={() => setShowDetailVehicule(false)}
                      >
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                    </span>
                  )}
                </div>
                <div className='row col-lg-12'>
                  <div className='col-lg-6'>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Date 1ère circulation</label>
                      <p className={'col-lg-8 p-1 mb-0'}>{immatriculation?.sdatePme &&
                          moment(immatriculation?.sdatePme).format('DD/MM/YYYY')}</p>
                    </div>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>N° série</label>
                      <p className={'col-lg-8 p-1 mb-0'}>{immatriculation.snoSerie}</p>
                    </div>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Carosserie</label>
                      <p className={'col-lg-8 p-1 mb-0'}>{immatriculation.scarrosserie}</p>
                    </div>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Code moteur</label>
                      <p className={'col-lg-8 p-1 mb-0'}>{immatriculation.scodeMoteur}</p>
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Cylindrée</label>
                      <p className={'col-lg-8 p-1 mb-0'}>{immatriculation.stecCylindree}</p>
                    </div>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Energie</label>
                      <p className={'col-lg-8 p-1 mb-0'}>{immatriculation.stecEnergie}</p>
                    </div>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Puissance CV</label>
                      <p className={'col-lg-8 p-1 mb-0'}>{immatriculation.spuissanceCv}</p>
                    </div>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Puissance fiscale</label>
                      <p className={'col-lg-8 p-1 mb-0'}>{immatriculation.spuissanceFiscale}</p>
                    </div>
                  </div>
                </div>
                {/*debut afficher plus et afficher moins*/}
                {/*<div className='d-flex align-items-center mb-3'>*/}
                {/*  <hr className='flex-grow-1' />*/}
                {/*  <a*/}
                {/*    className='text-primary fw-bold fs-6 mx-3'*/}
                {/*    style={{cursor: 'pointer'}}*/}
                {/*    onClick={() => setDisplayAdditionalInfoImmat(!displayAdditionalInfoImmat)}*/}
                {/*  >*/}
                {/*    <i*/}
                {/*      className={`bi bi-chevron-${displayAdditionalInfoImmat ? 'up' : 'down'} me-2`}*/}
                {/*    ></i>*/}
                {/*    Afficher {displayAdditionalInfoImmat ? 'moins' : 'plus'}*/}
                {/*  </a>*/}
                {/*  <hr className='flex-grow-1' />*/}
                {/*</div>*/}
                {/*fin afficher plus et afficher moins*/}
                {/*{displayAdditionalInfoImmat && (*/}
                <div className='row col-lg-12'>
                  <div className='col-lg-6'>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Code moteur tecdoc</label>
                      <p className={'col-lg-8 p-1 mb-0'}>
                        {immatriculation.stecCodeMoteurTecdocEquivalent}
                      </p>
                    </div>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Type</label>
                      <p className={'col-lg-8 p-1 mb-0'}>{immatriculation.stypeVin}</p>
                    </div>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Nombre portes</label>
                      <p className={'col-lg-8 p-1 mb-0'}>{immatriculation.stecNbPortes}</p>
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Type boîte</label>
                      <p className={'col-lg-8 p-1 mb-0'}>{immatriculation.stypeBoiteVitesse}</p>
                    </div>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Couleur</label>
                      <p className={'col-lg-8 p-1 mb-0'}>{immatriculation.scouleur}</p>
                    </div>
                  </div>
                </div>
                {/*)}*/}
              </>
            ) : (
              !vehicleInfo &&
              infoModele.length !== 0 && (
                <>
                  <div className='d-flex'>
                    <label className='col p-1 fw-bold fs-3 text-gray-600'>
                      {infoModele[0]?.marque?.nom} {infoModele[0]?.nom}{' '}
                      {infoModele[0]?.phase ? ' Phase ' + infoModele[0]?.phase : ''}
                    </label>
                    <div className='d-flex justify-content-end align-items-center gap-2'>
                      {isEditable && infoModele[0]?.isHorsType && (
                        <span
                          className={'btn btn-icon btn-bg-light btn-active-color-primary btn-sm'}
                        >
                          <i
                            className='ki-duotone ki-pencil fs-2x cursor-pointer'
                            style={{
                              color: '#ffcd3f',
                              transition: 'color 0.3s ease',
                            }}
                            data-tooltip-id='tooltip'
                            data-tooltip-content='Modifier les informations'
                            data-tooltip-place='right'
                            onClick={() => setIsEdit(!isEdit)}
                          >
                            <span className='path1'></span>
                            <span className='path2'></span>
                          </i>
                        </span>
                      )}
                      {closeBtn && (
                        <span
                          className={'btn btn-icon btn-bg-light btn-active-color-primary btn-sm'}
                        >
                          <i
                            className='ki-duotone ki-cross fs-3x cursor-pointer'
                            onClick={() => setShowDetailVehicule(false)}
                          >
                            <span className='path1'></span>
                            <span className='path2'></span>
                          </i>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Marque</label>
                      <p className={'col-lg-8 p-1 mb-0'}>
                        {!isEdit ? (
                          infoModele[0]?.marque?.nom ?? 'N/C'
                        ) : (
                          <input
                            type={'text'}
                            className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                              !dataV?.marque?.nom?.trim() ? 'border border-danger' : ''
                            }`}
                            name={'marque'}
                            placeholder={'Marque'}
                            value={dataV?.marque?.nom ?? ''}
                            onChange={(e) => handleInputChange('marque', e.target.value)}
                          />
                        )}
                      </p>
                    </div>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Modèle</label>
                      <p className={'col-lg-8 p-1 mb-0'}>
                        {!isEdit ? (
                          infoModele[0]?.nom ?? 'N/C'
                        ) : (
                          <input
                            type={'text'}
                            className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                              !dataV.nom.trim() ? 'border border-danger' : ''
                            }`}
                            name={'modele'}
                            placeholder={'Modèle'}
                            value={dataV?.nom ?? ''}
                            onChange={(e) => handleInputChange('nom', e.target.value)}
                          />
                        )}
                      </p>
                    </div>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Phase</label>
                      <p className={'col-lg-8 p-1 mb-0'}>
                        {!isEdit ? (
                          infoModele[0]?.phase ?? 'N/C'
                        ) : (
                          <input
                            type={'text'}
                            className={
                              'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                            }
                            name={'phase'}
                            placeholder={'Phase'}
                            value={dataV?.phase ?? ''}
                            onChange={(e) => handleInputChange('phase', e.target.value)}
                          />
                        )}
                      </p>
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Début phase</label>
                      <p className={'col-lg-8 p-1 mb-0'}>
                        {!isEdit ? (
                          infoModele[0]?.debutPhase ?? 'N/C'
                        ) : (
                          <input
                            type={'text'}
                            className={
                              'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                            }
                            name={'debutPhase'}
                            placeholder={'Début phase'}
                            value={dataV?.debutPhase ?? ''}
                            onChange={(e) => handleInputChange('debutPhase', e.target.value)}
                          />
                        )}
                      </p>
                    </div>
                    <div className='row mb-1'>
                      <label className='col-lg-4 p-1 fw-bold fs-6'>Fin phase</label>
                      <p className={'col-lg-8 p-1 mb-0'}>
                        {!isEdit ? (
                          infoModele[0]?.finPhase ?? 'N/C'
                        ) : (
                          <input
                            type={'text'}
                            className={
                              'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                            }
                            name={'finPhase'}
                            placeholder={'Fin phase'}
                            value={dataV?.finPhase ?? ''}
                            onChange={(e) => handleInputChange('finPhase', e.target.value)}
                          />
                        )}
                      </p>
                    </div>
                  </div>
                  {infoModele[0]?.isHorsType && (
                    <>
                      {/*<div className='d-flex align-items-center mb-3'>*/}
                      {/*  <hr className='flex-grow-1' />*/}
                      {/*  <a*/}
                      {/*    className='text-primary fw-bold fs-6 mx-3'*/}
                      {/*    style={{cursor: 'pointer'}}*/}
                      {/*    onClick={() => setDisplayAdditionalInfo(!displayAdditionalInfo)}*/}
                      {/*  >*/}
                      {/*    <i*/}
                      {/*      className={`bi bi-chevron-${displayAdditionalInfo ? 'up' : 'down'} me-2`}*/}
                      {/*    ></i>*/}
                      {/*    Afficher {displayAdditionalInfo ? 'moins' : 'plus'}*/}
                      {/*  </a>*/}
                      {/*  <hr className='flex-grow-1' />*/}
                      {/*</div>*/}

                      {/*{displayAdditionalInfo && (*/}
                      <>
                        <div className='col-lg-6'>
                          <div className='row mb-1'>
                            <label className='col-lg-4 p-1 fw-bold fs-6'>Code moteur</label>
                            <p className={'col-lg-8 p-1 mb-0'}>
                              {!isEdit ? (
                                infoModele[0]?.codeMoteur ?? 'N/C'
                              ) : (
                                <input
                                  type={'text'}
                                  className={
                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                  }
                                  name={'codeMoteur'}
                                  placeholder={'Code moteur'}
                                  value={dataV?.codeMoteur ?? ''}
                                  onChange={(e) => handleInputChange('codeMoteur', e.target.value)}
                                />
                              )}
                            </p>
                          </div>
                          <div className='row mb-1'>
                            <label className='col-lg-4 p-1 fw-bold fs-6'>Puissance CV</label>
                            <p className={'col-lg-8 p-1 mb-0'}>
                              {!isEdit ? (
                                infoModele[0]?.puissance ?? 'N/C'
                              ) : (
                                <input
                                  type={'text'}
                                  className={
                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                  }
                                  name={'puissance'}
                                  placeholder={'Puissance'}
                                  value={dataV?.puissance ?? ''}
                                  onChange={(e) => handleInputChange('puissance', e.target.value)}
                                />
                              )}
                            </p>
                          </div>
                          <div className='row mb-1'>
                            <label className='col-lg-4 p-1 fw-bold fs-6'>Cylindrée</label>
                            <p className={'col-lg-8 p-1 mb-0'}>
                              {!isEdit ? (
                                infoModele[0]?.cylindre ?? 'N/C'
                              ) : (
                                <input
                                  type={'text'}
                                  className={
                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                  }
                                  name={'cylindre'}
                                  placeholder={'Cylindre'}
                                  value={dataV?.cylindre ?? ''}
                                  onChange={(e) => handleInputChange('cylindre', e.target.value)}
                                />
                              )}
                            </p>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className='row mb-1'>
                            <label className='col-lg-4 p-1 fw-bold fs-6'>Groupe</label>
                            <p className={'col-lg-8 p-1 mb-0'}>
                              {!isEdit ? (
                                infoModele[0]?.type?.groupe?.libelle ?? 'N/C'
                              ) : (
                                <input
                                  type={'text'}
                                  className={
                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                  }
                                  name={'typeGroupe'}
                                  placeholder={'Type groupe'}
                                  value={dataV?.type?.groupe?.libelle ?? ''}
                                  onChange={(e) => handleInputChange('groupe', e.target.value)}
                                />
                              )}
                            </p>
                          </div>
                          <div className='row mb-1'>
                            <label className='col-lg-4 p-1 fw-bold fs-6'>Type</label>
                            <p className={'col-lg-8 p-1 mb-0'}>
                              {!isEdit ? (
                                infoModele[0]?.type?.libelle ?? 'N/C'
                              ) : (
                                <input
                                  type={'text'}
                                  className={
                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                  }
                                  name={'typeLibelle'}
                                  placeholder={'Libellé type'}
                                  value={dataV?.type?.libelle ?? ''}
                                  onChange={(e) => handleInputChange('type', e.target.value)}
                                />
                              )}
                            </p>
                          </div>
                          <div className='row mb-1'>
                            <label className='col-lg-4 p-1 fw-bold fs-6'>VIN</label>
                            <p className={'col-lg-8 p-1 mb-0'}>
                              {!isEdit ? (
                                infoModele[0]?.vin ?? 'N/C'
                              ) : (
                                <input
                                  type={'text'}
                                  className={
                                    'form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                  }
                                  name={'vin'}
                                  placeholder={'Vin'}
                                  value={dataV?.vin ?? ''}
                                  onChange={(e) => handleInputChange('vin', e.target.value)}
                                />
                              )}
                            </p>
                          </div>
                        </div>
                      </>
                      {/*)}*/}
                    </>
                  )}
                  {isEdit && (
                    <button
                      type='button'
                      className='btn btn-light'
                      onClick={handleSaveInfo}
                      disabled={dataV?.marque?.nom?.trim() === '' || dataV?.nom?.trim() === ''}
                    >
                      Enregistrer
                    </button>
                  )}
                </>
              )
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default VehicleData
